/* tslint:disable */

/* eslint-disable */

/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import type { AxiosInstance, AxiosPromise, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";

// @ts-ignore
import {
  BASE_PATH,
  BaseAPI,
  COLLECTION_FORMATS,
  RequestArgs,
  RequiredError,
  operationServerMap,
} from "../base";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  createRequestFunction,
  serializeDataIfNeeded,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  toPathString,
} from "../common";
import type { Configuration } from "../configuration";
// @ts-ignore
import { CreateStatsSessionRequestDto } from "../models";
// @ts-ignore
import { CreateStatsSessionResponseDto } from "../models";
// @ts-ignore
import { GetStatsListResponseDto } from "../models";
// @ts-ignore
import { GetStatsSessionResponseDto } from "../models";
// @ts-ignore
import { GetStatsSessionsResponseDto } from "../models";
// @ts-ignore
import { QuerySessionStatsFullResponseDto } from "../models";
// @ts-ignore
import { QuerySessionStatsRequestDto } from "../models";
// @ts-ignore
import { QuerySessionStatsResponseDto } from "../models";

/**
 * StatsControllerApi - axios parameter creator
 * @export
 */
export const StatsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {CreateStatsSessionRequestDto} createStatsSessionRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createStatsSession: async (
      createStatsSessionRequestDto: CreateStatsSessionRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createStatsSessionRequestDto' is not null or undefined
      assertParamExists(
        "createStatsSession",
        "createStatsSessionRequestDto",
        createStatsSessionRequestDto
      );
      const localVarPath = `/api/v2/stats/stats-sessions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createStatsSessionRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {string} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportSessionStatsCsv: async (
      userId: number,
      sessionId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("exportSessionStatsCsv", "userId", userId);
      // verify required parameter 'sessionId' is not null or undefined
      assertParamExists("exportSessionStatsCsv", "sessionId", sessionId);
      const localVarPath = `/api/v2/stats/stats-sessions/{userId}/{sessionId}/export-csv`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
        .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStatsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/v2/stats/stats-list`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {string} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStatsSession: async (
      userId: number,
      sessionId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("getStatsSession", "userId", userId);
      // verify required parameter 'sessionId' is not null or undefined
      assertParamExists("getStatsSession", "sessionId", sessionId);
      const localVarPath = `/api/v2/stats/stats-sessions/{userId}/{sessionId}`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
        .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStatsSessions: async (
      userId?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v2/stats/stats-sessions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (userId !== undefined) {
        localVarQueryParameter["userId"] = userId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {string} sessionId
     * @param {number} pageNumber
     * @param {number} pageSize
     * @param {QuerySessionStatsRequestDto} querySessionStatsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    querySessionStats: async (
      userId: number,
      sessionId: string,
      pageNumber: number,
      pageSize: number,
      querySessionStatsRequestDto: QuerySessionStatsRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("querySessionStats", "userId", userId);
      // verify required parameter 'sessionId' is not null or undefined
      assertParamExists("querySessionStats", "sessionId", sessionId);
      // verify required parameter 'pageNumber' is not null or undefined
      assertParamExists("querySessionStats", "pageNumber", pageNumber);
      // verify required parameter 'pageSize' is not null or undefined
      assertParamExists("querySessionStats", "pageSize", pageSize);
      // verify required parameter 'querySessionStatsRequestDto' is not null or undefined
      assertParamExists(
        "querySessionStats",
        "querySessionStatsRequestDto",
        querySessionStatsRequestDto
      );
      const localVarPath = `/api/v2/stats/stats-sessions/{userId}/{sessionId}/stats`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
        .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageNumber !== undefined) {
        localVarQueryParameter["pageNumber"] = pageNumber;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter["pageSize"] = pageSize;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        querySessionStatsRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {string} sessionId
     * @param {string} xStatId
     * @param {string} yStatId
     * @param {string} zStatId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    querySessionStatsFull: async (
      userId: number,
      sessionId: string,
      xStatId: string,
      yStatId: string,
      zStatId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("querySessionStatsFull", "userId", userId);
      // verify required parameter 'sessionId' is not null or undefined
      assertParamExists("querySessionStatsFull", "sessionId", sessionId);
      // verify required parameter 'xStatId' is not null or undefined
      assertParamExists("querySessionStatsFull", "xStatId", xStatId);
      // verify required parameter 'yStatId' is not null or undefined
      assertParamExists("querySessionStatsFull", "yStatId", yStatId);
      // verify required parameter 'zStatId' is not null or undefined
      assertParamExists("querySessionStatsFull", "zStatId", zStatId);
      const localVarPath = `/api/v2/stats/stats-sessions/{userId}/{sessionId}/stats-full`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
        .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xStatId !== undefined) {
        localVarQueryParameter["xStatId"] = xStatId;
      }

      if (yStatId !== undefined) {
        localVarQueryParameter["yStatId"] = yStatId;
      }

      if (zStatId !== undefined) {
        localVarQueryParameter["zStatId"] = zStatId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {string} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshStatsSession: async (
      userId: number,
      sessionId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("refreshStatsSession", "userId", userId);
      // verify required parameter 'sessionId' is not null or undefined
      assertParamExists("refreshStatsSession", "sessionId", sessionId);
      const localVarPath = `/api/v2/stats/stats-sessions/{userId}/{sessionId}/refresh`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
        .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PATCH", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * StatsControllerApi - functional programming interface
 * @export
 */
export const StatsControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = StatsControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CreateStatsSessionRequestDto} createStatsSessionRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createStatsSession(
      createStatsSessionRequestDto: CreateStatsSessionRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateStatsSessionResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createStatsSession(
        createStatsSessionRequestDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatsControllerApi.createStatsSession"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} userId
     * @param {string} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async exportSessionStatsCsv(
      userId: number,
      sessionId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.exportSessionStatsCsv(
        userId,
        sessionId,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatsControllerApi.exportSessionStatsCsv"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getStatsList(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStatsListResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getStatsList(options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatsControllerApi.getStatsList"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} userId
     * @param {string} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getStatsSession(
      userId: number,
      sessionId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStatsSessionResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getStatsSession(
        userId,
        sessionId,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatsControllerApi.getStatsSession"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getStatsSessions(
      userId?: number,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStatsSessionsResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getStatsSessions(
        userId,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatsControllerApi.getStatsSessions"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} userId
     * @param {string} sessionId
     * @param {number} pageNumber
     * @param {number} pageSize
     * @param {QuerySessionStatsRequestDto} querySessionStatsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async querySessionStats(
      userId: number,
      sessionId: string,
      pageNumber: number,
      pageSize: number,
      querySessionStatsRequestDto: QuerySessionStatsRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuerySessionStatsResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.querySessionStats(
        userId,
        sessionId,
        pageNumber,
        pageSize,
        querySessionStatsRequestDto,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatsControllerApi.querySessionStats"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} userId
     * @param {string} sessionId
     * @param {string} xStatId
     * @param {string} yStatId
     * @param {string} zStatId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async querySessionStatsFull(
      userId: number,
      sessionId: string,
      xStatId: string,
      yStatId: string,
      zStatId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<QuerySessionStatsFullResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.querySessionStatsFull(
        userId,
        sessionId,
        xStatId,
        yStatId,
        zStatId,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatsControllerApi.querySessionStatsFull"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} userId
     * @param {string} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async refreshStatsSession(
      userId: number,
      sessionId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.refreshStatsSession(
        userId,
        sessionId,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["StatsControllerApi.refreshStatsSession"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * StatsControllerApi - factory interface
 * @export
 */
export const StatsControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = StatsControllerApiFp(configuration);
  return {
    /**
     *
     * @param {CreateStatsSessionRequestDto} createStatsSessionRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createStatsSession(
      createStatsSessionRequestDto: CreateStatsSessionRequestDto,
      options?: any
    ): AxiosPromise<CreateStatsSessionResponseDto> {
      return localVarFp
        .createStatsSession(createStatsSessionRequestDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {string} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportSessionStatsCsv(
      userId: number,
      sessionId: string,
      options?: any
    ): AxiosPromise<object> {
      return localVarFp
        .exportSessionStatsCsv(userId, sessionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStatsList(options?: any): AxiosPromise<GetStatsListResponseDto> {
      return localVarFp.getStatsList(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {string} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStatsSession(
      userId: number,
      sessionId: string,
      options?: any
    ): AxiosPromise<GetStatsSessionResponseDto> {
      return localVarFp
        .getStatsSession(userId, sessionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStatsSessions(
      userId?: number,
      options?: any
    ): AxiosPromise<GetStatsSessionsResponseDto> {
      return localVarFp
        .getStatsSessions(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {string} sessionId
     * @param {number} pageNumber
     * @param {number} pageSize
     * @param {QuerySessionStatsRequestDto} querySessionStatsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    querySessionStats(
      userId: number,
      sessionId: string,
      pageNumber: number,
      pageSize: number,
      querySessionStatsRequestDto: QuerySessionStatsRequestDto,
      options?: any
    ): AxiosPromise<QuerySessionStatsResponseDto> {
      return localVarFp
        .querySessionStats(
          userId,
          sessionId,
          pageNumber,
          pageSize,
          querySessionStatsRequestDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {string} sessionId
     * @param {string} xStatId
     * @param {string} yStatId
     * @param {string} zStatId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    querySessionStatsFull(
      userId: number,
      sessionId: string,
      xStatId: string,
      yStatId: string,
      zStatId: string,
      options?: any
    ): AxiosPromise<QuerySessionStatsFullResponseDto> {
      return localVarFp
        .querySessionStatsFull(userId, sessionId, xStatId, yStatId, zStatId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {string} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshStatsSession(userId: number, sessionId: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .refreshStatsSession(userId, sessionId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * StatsControllerApi - object-oriented interface
 * @export
 * @class StatsControllerApi
 * @extends {BaseAPI}
 */
export class StatsControllerApi extends BaseAPI {
  /**
   *
   * @param {CreateStatsSessionRequestDto} createStatsSessionRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsControllerApi
   */
  public createStatsSession(
    createStatsSessionRequestDto: CreateStatsSessionRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return StatsControllerApiFp(this.configuration)
      .createStatsSession(createStatsSessionRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} userId
   * @param {string} sessionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsControllerApi
   */
  public exportSessionStatsCsv(
    userId: number,
    sessionId: string,
    options?: RawAxiosRequestConfig
  ) {
    return StatsControllerApiFp(this.configuration)
      .exportSessionStatsCsv(userId, sessionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsControllerApi
   */
  public getStatsList(options?: RawAxiosRequestConfig) {
    return StatsControllerApiFp(this.configuration)
      .getStatsList(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} userId
   * @param {string} sessionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsControllerApi
   */
  public getStatsSession(userId: number, sessionId: string, options?: RawAxiosRequestConfig) {
    return StatsControllerApiFp(this.configuration)
      .getStatsSession(userId, sessionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [userId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsControllerApi
   */
  public getStatsSessions(userId?: number, options?: RawAxiosRequestConfig) {
    return StatsControllerApiFp(this.configuration)
      .getStatsSessions(userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} userId
   * @param {string} sessionId
   * @param {number} pageNumber
   * @param {number} pageSize
   * @param {QuerySessionStatsRequestDto} querySessionStatsRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsControllerApi
   */
  public querySessionStats(
    userId: number,
    sessionId: string,
    pageNumber: number,
    pageSize: number,
    querySessionStatsRequestDto: QuerySessionStatsRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return StatsControllerApiFp(this.configuration)
      .querySessionStats(
        userId,
        sessionId,
        pageNumber,
        pageSize,
        querySessionStatsRequestDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} userId
   * @param {string} sessionId
   * @param {string} xStatId
   * @param {string} yStatId
   * @param {string} zStatId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsControllerApi
   */
  public querySessionStatsFull(
    userId: number,
    sessionId: string,
    xStatId: string,
    yStatId: string,
    zStatId: string,
    options?: RawAxiosRequestConfig
  ) {
    return StatsControllerApiFp(this.configuration)
      .querySessionStatsFull(userId, sessionId, xStatId, yStatId, zStatId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} userId
   * @param {string} sessionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatsControllerApi
   */
  public refreshStatsSession(
    userId: number,
    sessionId: string,
    options?: RawAxiosRequestConfig
  ) {
    return StatsControllerApiFp(this.configuration)
      .refreshStatsSession(userId, sessionId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
